export default {
  default: {},
  hidden: {
    shouldDisplay: false
  }
}
